// extracted by mini-css-extract-plugin
module.exports = {"loading-spinner":"hM-Yq_cm_DOxGbQbjaPkq"};